import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppData } from '../AppContext';
import './OtherProducts.css';

const ICONS = [
  <svg key="0" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M60 8L95 22V55C95 75 60 92 60 92C60 92 25 75 25 55V22L60 8Z"
      fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.65)" strokeWidth="2"/>
    <ellipse cx="60" cy="52" rx="26" ry="14" fill="none"
      stroke="rgba(255,255,255,0.35)" strokeWidth="1.5" strokeDasharray="4 3"/>
    <circle cx="86" cy="52" r="4" fill="rgba(255,255,255,0.85)"/>
    <text x="48" y="58" fontSize="17" fontWeight="bold" fill="white" fontFamily="monospace">Zn</text>
  </svg>,
  <svg key="1" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="15" y="64" width="90" height="16" rx="4"
      fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.35)" strokeWidth="1.5"/>
    <rect x="20" y="46" width="80" height="16" rx="4"
      fill="rgba(255,255,255,0.22)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5"/>
    <rect x="25" y="28" width="70" height="16" rx="4"
      fill="rgba(255,255,255,0.38)" stroke="rgba(255,255,255,0.8)" strokeWidth="2"/>
    <path d="M86 28 Q90 16 85 9" stroke="rgba(255,255,255,0.65)" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="84" cy="7" r="3.5" fill="rgba(255,255,255,0.8)"/>
  </svg>,
  <svg key="2" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="50" r="11" fill="rgba(255,255,255,0.9)"/>
    <line x1="60" y1="50" x2="33" y2="24" stroke="rgba(255,255,255,0.55)" strokeWidth="2"/>
    <circle cx="33" cy="24" r="8" fill="rgba(255,255,255,0.55)"/>
    <line x1="60" y1="50" x2="90" y2="28" stroke="rgba(255,255,255,0.55)" strokeWidth="2"/>
    <circle cx="90" cy="28" r="8" fill="rgba(255,255,255,0.55)"/>
    <line x1="60" y1="50" x2="90" y2="74" stroke="rgba(255,255,255,0.55)" strokeWidth="2"/>
    <circle cx="90" cy="74" r="8" fill="rgba(255,255,255,0.55)"/>
    <line x1="60" y1="50" x2="33" y2="74" stroke="rgba(255,255,255,0.55)" strokeWidth="2"/>
    <circle cx="33" cy="74" r="8" fill="rgba(255,255,255,0.55)"/>
  </svg>,
  <svg key="3" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="48" r="22" fill="rgba(255,255,255,0.2)" stroke="rgba(255,255,255,0.8)" strokeWidth="2"/>
    <line x1="60" y1="20" x2="60" y2="10" stroke="rgba(255,255,255,0.7)" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="60" y1="76" x2="60" y2="86" stroke="rgba(255,255,255,0.7)" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="32" y1="48" x2="22" y2="48" stroke="rgba(255,255,255,0.7)" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="88" y1="48" x2="98" y2="48" stroke="rgba(255,255,255,0.7)" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="40" y1="27" x2="33" y2="20" stroke="rgba(255,255,255,0.5)" strokeWidth="2" strokeLinecap="round"/>
    <line x1="80" y1="27" x2="87" y2="20" stroke="rgba(255,255,255,0.5)" strokeWidth="2" strokeLinecap="round"/>
    <line x1="40" y1="69" x2="33" y2="76" stroke="rgba(255,255,255,0.5)" strokeWidth="2" strokeLinecap="round"/>
    <line x1="80" y1="69" x2="87" y2="76" stroke="rgba(255,255,255,0.5)" strokeWidth="2" strokeLinecap="round"/>
    <path d="M46 40 Q54 33 68 37" stroke="rgba(255,255,255,0.95)" strokeWidth="3" strokeLinecap="round"/>
  </svg>,
  <svg key="4" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="18" y="38" width="52" height="24" rx="6"
      fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5"/>
    <rect x="24" y="62" width="20" height="22" rx="5"
      fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.45)" strokeWidth="1.5"/>
    <rect x="70" y="44" width="14" height="12" rx="3"
      fill="rgba(255,255,255,0.28)" stroke="rgba(255,255,255,0.7)" strokeWidth="1.5"/>
    <circle cx="93" cy="39" r="2.5" fill="rgba(255,255,255,0.75)"/>
    <circle cx="100" cy="48" r="2" fill="rgba(255,255,255,0.55)"/>
    <circle cx="97" cy="57" r="3" fill="rgba(255,255,255,0.65)"/>
    <circle cx="108" cy="43" r="1.5" fill="rgba(255,255,255,0.4)"/>
    <circle cx="104" cy="35" r="2" fill="rgba(255,255,255,0.5)"/>
  </svg>,
  <svg key="5" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="68" width="96" height="18" rx="3"
      fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5"/>
    <path d="M38 68Q32 52 40 40Q36 50 48 46Q38 36 52 18Q50 34 62 32Q52 44 60 48Q68 40 64 56Q74 48 70 40Q82 52 76 68Z"
      fill="rgba(255,255,255,0.32)" stroke="rgba(255,255,255,0.7)" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>,
];

function ProductCard({ product, index }) {
  const [open, setOpen] = useState(false);
  const icon = ICONS[index % ICONS.length];
  const gradFrom = product.gradientFrom || '#1e3a5f';
  const gradTo   = product.gradientTo   || '#2563eb';

  return (
    <div className="op-card">
      <div className="op-card-media">
        {product.image
          ? <img src={product.image} alt={product.name} className="op-card-img" />
          : (
            <div className="op-card-illustration"
              style={{ background: `linear-gradient(135deg, ${gradFrom}, ${gradTo})` }}>
              {icon}
            </div>
          )
        }
        <div className="op-card-media-overlay" />
        {product.badge && (
          <span className="op-badge" style={{ background: product.badgeColor || '#2563eb' }}>
            {product.badge}
          </span>
        )}
      </div>

      <div className="op-card-body">
        <span className="op-card-cat">{product.category}</span>
        <h3 className="op-card-name">{product.name}</h3>
        <p className="op-card-desc">{product.desc}</p>
        {(product.features || []).length > 0 && (
          <ul className="op-features">
            {product.features.map((f, i) => (
              <li key={i} className="op-feature-item">
                <span className="op-feature-check">&#10003;</span>
                {f}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="op-card-footer">
        <button
          className={'op-specs-toggle' + (open ? ' op-specs-toggle--open' : '')}
          onClick={() => setOpen(v => !v)}
        >
          {open ? '\u25b2 Hide Specs' : '\u25bc View Specs'}
        </button>
        <Link to="/contact" className="op-enquire-btn">Enquire &rarr;</Link>
      </div>

      {open && (
        <div className="op-specs-panel">
          <p className="op-specs-heading">Technical Specifications</p>
          <table className="op-specs-table">
            <tbody>
              {(product.specs || []).map((sp, i) => (
                <tr key={i} className={sp.bold ? 'op-spec-bold' : ''}>
                  <td className="op-spec-label">{sp.label}</td>
                  <td className="op-spec-value">{sp.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <Link to="/contact" className="op-datasheet-btn">Request Full Datasheet</Link>
        </div>
      )}
    </div>
  );
}

export default function OtherProducts() {
  const { otherProducts } = useAppData();

  return (
    <div className="other-products-page">
      <section className="op-hero">
        <div className="op-hero-bg" aria-hidden="true">
          <div className="op-hero-orb op-hero-orb1" />
          <div className="op-hero-orb op-hero-orb2" />
        </div>
        <div className="op-hero-inner">
          <span className="op-eyebrow">Our Full Range</span>
          <h1 className="op-title">Other Products</h1>
          <p className="op-subtitle">
            Beyond ZINGA Film Galvanization, John Galt Zinga Technologies supplies a comprehensive
            range of protective coatings and surface-treatment solutions for industrial, marine and
            structural applications.
          </p>
          <div className="op-hero-btns">
            <Link to="/contact" className="op-btn op-btn-primary op-btn-lg">Enquire Now</Link>
            <Link to="/products" className="op-btn op-btn-outline op-btn-lg">View ZINGA Products</Link>
          </div>
        </div>
      </section>

      <div className="op-ribbon">
        <div className="op-ribbon-stat"><strong>{otherProducts.length}</strong>Product Categories</div>
        <div className="op-ribbon-divider" />
        <div className="op-ribbon-stat"><strong>ISO 9001</strong>Certified Quality</div>
        <div className="op-ribbon-divider" />
        <div className="op-ribbon-stat"><strong>20+ Years</strong>Industry Experience</div>
        <div className="op-ribbon-divider" />
        <div className="op-ribbon-stat"><strong>Pan-India</strong>Distribution Network</div>
      </div>

      <section className="op-section">
        <div className="op-section-head">
          <h2 className="op-section-title">Protective Coating Solutions</h2>
          <p className="op-section-sub">
            Each product is engineered for demanding environments - from offshore platforms
            to industrial structures - delivering long-term corrosion protection.
          </p>
        </div>
        <div className="op-grid">
          {otherProducts.map((product, idx) => (
            <ProductCard key={product.id || idx} product={product} index={idx} />
          ))}
        </div>
      </section>

      <section className="op-cta-section">
        <div className="op-cta-inner">
          <div className="op-cta-text">
            <h2>Need a Custom Coating Solution?</h2>
            <p>
              Our technical team recommends the right product system for your specific
              application, environment and budget. Technical datasheets available on request.
            </p>
          </div>
          <div className="op-cta-actions">
            <Link to="/contact" className="op-btn op-btn-primary op-btn-lg">Contact Our Experts</Link>
            <Link to="/products" className="op-btn op-btn-outline op-btn-lg">View ZINGA Products</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
